import * as React from 'react';

var _path, _path2, _path3, _path4;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgRecipeOutline24 = function SvgRecipeOutline24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 4 4.022 6 3 5.063M6 8l-1.978 2L3 9.063M6 12l-1.978 2L3 13.063M11 5H7m4 4H7m9-3c0 .439-.173.64-.412.92-.262.305-.588.686-.588 1.414 0 .727.326 1.108.588 1.413.239.28.412.481.412.92 0 .438-.173.64-.412.92-.262.305-.588.685-.588 1.413m4-7c0 .439-.173.64-.412.92-.262.305-.588.686-.588 1.414 0 .727.326 1.108.588 1.413.239.28.412.481.412.92 0 .438-.173.64-.412.92-.262.305-.588.685-.588 1.413m5.499 1.5a8.11 8.11 0 0 1-4.8 7.262c-1.304.52-2.276.745-3.218.738-.944-.008-1.903-.25-3.183-.74A8.11 8.11 0 0 1 7.5 14.5h16z",
    stroke: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 2.006h10v12.071h1V1H1v18.107h7.406a8.52 8.52 0 0 1-.57-1.006H2V2.006z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    d: "M22 22.5H9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    transform: "rotate(134.83 9.41 9.81)",
    stroke: "currentColor",
    d: "M0-.5h5.674"
  })));
};

var RecipeOutline24Svg = SvgRecipeOutline24;

export { RecipeOutline24Svg as default };
//# sourceMappingURL=RecipeOutline24.svg.js.map
